var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y1qzcqpwba",
    d: "M0.694 0.522L24.384 0.522 24.384 17.86 0.694 17.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8kl04mb7tc",
    d: "M0 0.846L25.811 0.846 25.811 16.2 0 16.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .163) translate(1.8 .378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m8vufhx36b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y1qzcqpwba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M12.6.522L1.03 3.466c-.198.05-.336.23-.336.436 0 .278.248.49.521.442l.356-.085v13.112c0 .27.218.49.486.49.267 0 .484-.22.484-.49v-1.257h20.118v1.257c0 .27.217.49.485.49.267 0 .484-.22.484-.49V4.303l.235.033c.275.04.522-.177.522-.456 0-.212-.144-.396-.347-.448L12.6.522z",
    mask: "url(#m8vufhx36b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .163) translate(0 11.178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dn67wwpiud",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8kl04mb7tc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M3.636 11.607l.019.627.985 3.966h1.006l-.517-3.97h.918v.909c0 .172.138.31.308.31.171 0 .31-.138.31-.31v-.91h.791v.91c0 .172.139.31.309.31.17 0 .309-.138.309-.31v-.918l1.214-1.485-4.27-.937-1.382 1.808zm10.865-.801l.525.987-1.038 4.407h-1.006l.7-5.394h.82zm10.2.915v3.802c0 .374-.3.677-.671.677h-.84l-5.747-6.003V16.2h-1.008l-.426-3.97-1.058-2.034H9.68L4.772 9.12l-1.747 2.296V16.2H2.017l-.404-5.597.404-2.439-.404-2.82V1.659c-.444 0-.806.365-.806.813v7.725H0V2.472C0 1.574.722.846 1.613.846h15.415c.75 0 1.439.42 1.786 1.091l4.477 8.674 2.52-.008-1.11 1.118z",
    mask: "url(#dn67wwpiud)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M23.884 23.788c0 .188-.15.34-.337.34-.186 0-.338-.152-.338-.34 0-.188.152-.34.338-.34.186 0 .337.152.337.34",
    transform: "translate(0 .163)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCows);
export default __webpack_public_path__ + "static/media/cows.c2fd567c1141adb0093f9430ff683a74.svg";
export { ForwardRef as ReactComponent };